import cn from 'classnames'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import { DropdownOptionModel } from 'ext-ui/components/Dropdown/components/DropdownOption/DropdownOption'
import Pill from 'ext-ui/components/Pill/Pill'
import { blue400 } from 'ext-ui/style/colors'
import React, { ComponentPropsWithRef } from 'react'
import SvgCheckFilled from 'src/components/Svgs/SvgCheckFilled'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

import styles from './CreditCardDropdownOption.style'

export interface CreditCardDropdownOptionDetails {
  isBudget: boolean
  imageUrl: string
}

type DropdownOptionProps =
  DropdownOptionModel<CreditCardDropdownOptionDetails> &
    ComponentPropsWithRef<'li'> & {
      multi?: boolean
      highlighted?: boolean
    }
const CreditCardDropdownOption = React.forwardRef<
  HTMLLIElement,
  DropdownOptionProps
>((props, ref) => {
  const {
    value,
    label,
    sublabel,
    details,
    pill,
    bold = true,
    disabled,
    selected = false,
    variant = 'medium',
    highlighted = false,
    multi,
    className,
    ...rest
  } = props
  const translate = useTranslate()

  return (
    <li
      ref={ref}
      role="option"
      tabIndex={0}
      aria-selected={selected}
      aria-disabled={disabled}
      {...rest}
      className={cn('CreditCardDropdownOption', className, variant, {
        disabled,
        selected,
        highlighted,
      })}
      css={styles}
    >
      {!multi && (
        <div className="CreditCardDropdownOption selected-icon">
          {selected && <SvgCheckFilled fill={blue400} />}
        </div>
      )}
      {multi && (
        <Checkbox
          aria-label={translate('Credit Card Checkbox')}
          className={'CreditCardDropdownOption checkbox'}
          checked={selected}
        />
      )}
      <img
        src={details?.imageUrl}
        css={css`
          width: ${details?.isBudget ? 20 : 30}px;
          ${!details?.isBudget && `border-radius: 3.37%/5.92%;`}
          border-radius: 3.37%/5.92%;
        `}
        alt={''}
      />
      <div className="option-label-wrapper">
        <div className="flex-row gap-2 align-center">
          <span className={cn('ellipsis', { bold, secondary: value === '' })}>
            {label ?? value}
          </span>
          {pill &&
            (typeof pill === 'string' ? (
              <Pill size={'small'}>{pill}</Pill>
            ) : (
              <Pill {...pill} />
            ))}
        </div>
        {sublabel && <span className="option-sublabel">{sublabel}</span>}
      </div>
    </li>
  )
})

export default CreditCardDropdownOption
